import React from "react";
import "../styles/stepSection.css";
import { MdFactory } from "react-icons/md";
import { IoShirtSharp, IoFastFoodOutline  } from "react-icons/io5";
import { LuPackageOpen } from "react-icons/lu";

const steps = [
  {
    step: "Step 01",
    title: "Manufacturing Industries",
    desc: "Enhances production by monitoring run time, stop time, and machine output, helping manufacturers minimize breakdown time and increase overall efficiency.",
    icon: <MdFactory />,
  },
  {
    step: "Step 02",
    title: "Textile & Garment Industry",
    desc: "Keeps track of stitching and cutting machine activity and production count, enabling accurate performance measurement and smoother production planning.",
    icon: <IoShirtSharp />,
  },
  {
    step: "Step 03",
    title: "Packaging & Printing Units",
    desc: "Provides real-time status of printing and packaging machines with detailed runtime and output data to boost throughput and minimize idle hours.",
    icon: <LuPackageOpen />,
  },
  {
    step: "Step 04",
    title: "Food Processing Plants",
    desc: "Monitors machine performance and downtime across processing lines to ensure continuous production flow and better shift-wise productivity management.",
    icon: <IoFastFoodOutline />,
  },
];

export default function StepsSection() {
  return (
    <div className="steps-section">
      <button className="how-it-works-btn">Who We Serve</button>
      <h2 className="steps-title">
        From <span className="highlight">Machine Data </span> Intelligent Productivity Decisions-
         <span className="highlight">Seamlessly</span> and at Scale
      </h2>

      {/* Progress Line */}
      <div className="steps-progress">
        {steps.map((_, i) => (
          <div key={i} className="progress-dot"></div>
        ))}
      </div>

      {/* Steps Cards */}
      <div className="steps-container">
        {steps.map((step, i) => (
          <div key={i} className="step-card">
            {/* <div className="step-badge">{step.step}</div> */}
            <div className="step-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>

    </div>
  );
}
